export default __webpack_public_path__ + "static/media/_DSC0215.a3df782b.JPG";